import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { CustomButton } from '../../common/custom-button/customButton';
import { Box, Stack } from '@mui/system';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { ADD_BULK_STAKEHOLDER, CALCULATE_IS_MBR, CALCULATE_MBR, GET_ALL_STAKEHOLDERS, GET_ANNUAL_MBR, GET_APPROVED_STAKEHOLDERS, GET_MONTHLY_MBR, GET_SAFETY_STOCK, GET_STAKEHOLDER_BY_TYPE, UPDATE_MONTHLY_MBR, UPDATE_SAFETY_STOCK } from '../../common/URLs';

import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { userData } from '../../common/spinLoader';
import UploadIcon from '@mui/icons-material/Upload';
import { DataGrid, GridEditInputCell, GridToolbarQuickFilter, GridToolbarExport, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import { DEMAND_CONSTANTS, DEMAND_ROLES, PROD } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import { CalculateIcon, SaveIcon, UpdateIcon } from '../../common/icons';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import apiClient from '../../axios';

export const SafetyStockPile = () => {
  const { t } = useTranslation();
  const uuid = localStorage.getItem('uuid');
  const [apiFormattedData, setApiFormattedData] = useState([]);
  const userLoggedIn = userData.user.userRoles?.[0].roleName
  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [combinedFinalMbrData, setCombinedFinalMbrData] = useState([]);
  const [stakeholderCommonData, setStakeholderCommonData] = React.useState([]);
  const [isUploadBtnDisable, setIsUploadBtnDisable] = useState(true);
  const [updateMbrData, setUpdateMbrData] = useState([]);
  const [safetyStockData, setSafetyStockData] = React.useState([]);
  const [isAddDisabled, setIsAddDisabled] = React.useState(true);
  const [showAddLleBtn, setShowAddLleBtn] = React.useState(true);
  const [pageSize, setPageSize] = React.useState(10);

  const [updateSafetyStockDialog, setUpdateSafetyStockDialog] = useState(false);
  const handleUpdateSafetyStockDialogOpen = () => setUpdateSafetyStockDialog(true);
  const handleUpdateSafetyStockDialogClose = () => setUpdateSafetyStockDialog(false);
  const [calculateIsMbrDialog, setCalculateIsMbrDialog] = useState(false);
  const handleCalculateIsMbrDialogOpen = () => setCalculateIsMbrDialog(true);
  const handleCalculateIsMbrDialogClose = () => setCalculateIsMbrDialog(false);

  const StyledBox = styled(Box)(({ theme }) => ({
    height: "inherit",
    width: '100%',
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: 'rgb(255,215,115, 0.19)',
      color: '#1a3e72',
      '& .MuiInputBase-root': {
        height: '100%',
      },
    },
    '& .Mui-error': {
      backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
      color: theme.palette.error.main,
    },
  }));

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

    function EditInputCell(props) {
          const { error, id, value: valueProp, field } = props;
          const [value, setValue] = useState(valueProp);
          const apiRef = useGridApiContext();
  
          const handleChange = (event) => {
              const newValue = event.target.value; 
              apiRef.current.setEditCellValue({ id, field, value: newValue });
              setValue(newValue);
          };
  
          useEffect(() => {
              setValue(valueProp);
          }, [valueProp]);
          
          return (
              <StyledTooltip open={!!error} title={error}>
                  <GridEditInputCell {...props} value={value} onChange={handleChange} />
             </StyledTooltip>
          );
      }

  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  const columns = [
    { field: 'stakeholderURN', headerName: 'URN', width: 190 },
    { field: 'stakeholderType', headerName: 'Type', },
    { field: 'name', headerName: t('preReg.name'), width: 200 },
    // { field: 'state', headerName: 'State', width: 150,},
    // { field: 'district', headerName: 'District',width: 200,},
    {
      field: 'Apr', headerName: 'APR', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'May', headerName: 'MAY', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jun', headerName: 'JUN', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jul', headerName: 'JUL', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Aug', headerName: 'AUG', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Sep', headerName: 'SEP', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Oct', headerName: 'OCT', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Nov', headerName: 'NOV', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Dec', headerName: 'DEC', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jan', headerName: 'JAN', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Feb', headerName: 'FEB', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Mar', headerName: 'MAR', editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner), type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
  ];


  const getSelectedValue = (dataToBePassed) => {
    setSelectedFinancialYear(dataToBePassed);
    getStakeholderByTypeApi(dataToBePassed);
    setIsUploadBtnDisable(false);
    setIsAddDisabled(false);
    setShowAddLleBtn(true);

  }
  const addLLEBtnApi = () => {
    loaderService.showLoader();
    let res = [];
    const temp = stakeholderCommonData === null || stakeholderCommonData?.length === 0 ? toast.info(DEMAND_CONSTANTS.NoDataMessage) :
      stakeholderCommonData?.map((data) => {
        let tempData = { ...data }
        tempData.safetyStockQty = 0
        return {
          'stakeholderURN': tempData.urn,
          'safetyStockQty': tempData.safetyStockQty,
          'stakeholderType': tempData.stakeHolderType,
          'name': tempData.name,
          // 'state': tempData.lleMasters[0]?.state,
          // 'district': tempData.lleMasters[0]?.district
        }
      })
    res = temp?.filter(el => {
      return !safetyStockData.find(element => {
        return element.stakeholderURN === el.stakeholderURN;
      });
    });
    let finalData = [...res, ...safetyStockData]
    setSafetyStockData(finalData);
    setShowAddLleBtn(false);
    loaderService.hideLoader();
  }
  const CustomToolbar = () => {
    const exportToExcel = (data) => {
      const ws = XLSX.utils.json_to_sheet(combinedFinalMbrData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      XLSX.writeFile(wb, "SafetyStockPile.xlsx");
    };

    return (
      <>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'right' }}>
          <GridToolbarQuickFilter />
        </Box>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'left' }}>
          <Button startIcon={<DownloadIcon />} onClick={() => exportToExcel(combinedFinalMbrData)}>Download</Button>

        </Box>
      </>

    );
  }

  const processRowUpdate = (newRow, oldRow) => {
    console.log("newRow", newRow)
    const changedField = Object.keys(newRow).find(
      (key) => newRow[key] !== oldRow[key]
    );
    let data = {
      "stakeholderURN": newRow.stakeholderURN,
      "stakeholderType": newRow.stakeholderType,
      "month": changedField,
      "name": newRow.name,
      "safetyStockQty": parseFloat(newRow[changedField])
    }
    const arrTemp = [...apiFormattedData]
    if (arrTemp.length !== 0) {
      let filteredData = arrTemp.filter(item => item.stakeholderURN === data.stakeholderURN && item.month === data.month)
      if (filteredData.length === 0) arrTemp.push(data);
      else {
        arrTemp.map((item) => {
          if (item.stakeholderURN === data.stakeholderURN && item.month === data.month) {
            item.safetyStockQty = data.safetyStockQty
          }
        })
      }
    } else { arrTemp.push(data) }
    setApiFormattedData(arrTemp)
    safetyStockData.forEach((item) => {
      if (item.stakeholderURN === newRow.stakeholderURN) {
        Object.keys(newRow).map((rowItem) => item[rowItem] = newRow[rowItem])
        item.type = "new"
      }
    })
    return newRow
  };
    

  // -----------------API Calls-------------------

  const getStakeholderByTypeApi = async (dataToBePassed) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'LLE'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const dataFromAPi = response.data.stakeHolders ? response.data.stakeHolders : []
        const temp = dataFromAPi?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'LLE'
          return tempData
        })
        getStakeholderByTypeISApi(dataToBePassed, temp);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getStakeholderByTypeISApi = async (dataToBePassed, lleApiData) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'Interim Storage Operator'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const dataFromApi = response.data.stakeHolders ? response.data.stakeHolders : [];
        const temp = dataFromApi?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'IS'
          return tempData
        })
        let mergedData = [...temp, ...lleApiData]
        setStakeholderCommonData(mergedData);
        getSafetyStockApi(dataToBePassed, mergedData, 'firstCall');
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getSafetyStockApi = (year, response2, type) => {
    loaderService.showLoader();
    apiClient.post(GET_SAFETY_STOCK,
      {
        "financialYear": year,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let response1 = response?.data?.safetyVMLst;
        if (type === 'firstCall') {
          const result = response1.map((data1) => {
            const matchingData2 = response2.find((data2) => {
              const data1Id = data1.stakeholderURN;
              const data2Id = data2.urn;
              return data2Id === data1Id
            });
            return Object.assign({}, data1, matchingData2);
          })
          let finalData = result?.map((item) => {
            let mhp = item?.monthWiseSafetyStockQty
            return {
              'stakeholderURN': item.stakeholderURN,
              'stakeholderType': item.stakeholderType,
              'name': item.name,
              'Apr': mhp.Apr ? mhp.Apr : 0,
              'May': mhp.May ? mhp.May : 0,
              'Jun': mhp.Jun ? mhp.Jun : 0,
              'Jul': mhp.Jul ? mhp.Jul : 0,
              'Aug': mhp.Aug ? mhp.Aug : 0,
              'Sep': mhp.Sep ? mhp.Sep : 0,
              'Oct': mhp.Oct ? mhp.Oct : 0,
              'Nov': mhp.Nov ? mhp.Nov : 0,
              'Dec': mhp.Dec ? mhp.Dec : 0,
              'Jan': mhp.Jan ? mhp.Jan : 0,
              'Feb': mhp.Feb ? mhp.Feb : 0,
              'Mar': mhp.Mar ? mhp.Mar : 0,
            }
          })
          setSafetyStockData(finalData);
          loaderService.hideLoader();

        } else if (type === 'afterUpdateCall') {
          let finalData = response1?.map((item) => {
            let mhp = item?.monthWiseSafetyStockQty
            return {
              'stakeholderURN': item.stakeholderURN,
              'stakeholderType': item.stakeholderType,
              'name': item.name,
              'Apr': mhp.Apr ? mhp.Apr : 0,
              'May': mhp.May ? mhp.May : 0,
              'Jun': mhp.Jun ? mhp.Jun : 0,
              'Jul': mhp.Jul ? mhp.Jul : 0,
              'Aug': mhp.Aug ? mhp.Aug : 0,
              'Sep': mhp.Sep ? mhp.Sep : 0,
              'Oct': mhp.Oct ? mhp.Oct : 0,
              'Nov': mhp.Nov ? mhp.Nov : 0,
              'Dec': mhp.Dec ? mhp.Dec : 0,
              'Jan': mhp.Jan ? mhp.Jan : 0,
              'Feb': mhp.Feb ? mhp.Feb : 0,
              'Mar': mhp.Mar ? mhp.Mar : 0,
            }
          })
          setSafetyStockData(finalData);
          loaderService.hideLoader();
        };

        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const onConfirmUpdateSafetyStock = () => {
    handleUpdateSafetyStockDialogClose();
    loaderService.showLoader();
    apiClient.post(UPDATE_SAFETY_STOCK + `?userId=${uuid}`,
      {
        "financialYear": selectedFinancialYear,
        "lleLst": apiFormattedData
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        getSafetyStockApi(selectedFinancialYear, [], 'afterUpdateCall');
        setShowAddLleBtn(true);
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const updateSafetyStockApi = (year) => {
    handleUpdateSafetyStockDialogOpen();
  }

  const onConfirmCalculateIsMbr = () => {
    handleCalculateIsMbrDialogClose();
    loaderService.showLoader();
    apiClient.post(CALCULATE_IS_MBR,
      {
        "financialYear": selectedFinancialYear,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (response.data.isSuccess === true) toast.success(response.data.message)
        else toast.error(response.data.message);
        getSafetyStockApi(selectedFinancialYear, [], 'afterUpdateCall');
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const calculateIsMbr = () => {
    handleCalculateIsMbrDialogOpen();
  }


  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={12}>
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM09</p>}
        <Card style={{ marginBottom: 10 }}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={2}>
                <FinancialYearDropdown selectedValue={getSelectedValue} />
              </Grid>
              {userLoggedIn === DEMAND_ROLES.DemandPlanner &&
                <Grid item xs={12} lg={10} >
                  <Stack direction="row" spacing={1} style={{ float: 'right' }}>
                    <CustomButton startIcon={<UpdateIcon />} title="Update Safety Stock" disabled={isAddDisabled} onClick={(e) => updateSafetyStockApi(e)} />
                    {showAddLleBtn && <Button variant="contained" startIcon={<AddIcon />} disabled={isAddDisabled} onClick={() => addLLEBtnApi()}>Add Stakeholder</Button>}
                    <CustomButton startIcon={<CalculateIcon />} title="Calculate IS MBR" disabled={isAddDisabled} onClick={() => calculateIsMbr()} />
                  </Stack>
                </Grid>}
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Box sx={{
              height: '300', width: '100%', display: "flex",
              justifyContent: "center",
              alignItems: "center",
              '& .super-app-theme--header': {
                wordWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'initial',
              },
              '& .MuiDataGrid-cell--editable': {
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
              },'& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },

            }}>
             
                <DataGrid
                  autoHeight
                  columns={columns}
                  rows={safetyStockData}
                  getRowId={(row) => row?.stakeholderURN}
                  processRowUpdate={processRowUpdate}
                  components={{ Toolbar: CustomDataGridToolbar }}
                  componentsProps={{toolbar: {rows: safetyStockData, columns: columns, fileName: "Safety_Stock_Data.xlsx", isExportToExcel: true }}}
                  experimentalFeatures={{ newEditingApi: true }}
                  initialState={{ pinnedColumns: { left: ['stakeholderUrn', 'stakeholderType'] } }}
                  pageSize={pageSize}
                  onPageSizeChange={(newPage) => setPageSize(newPage)}
                />
              
            </Box>
          </CardContent>
        </Card>

      </Grid>
      <ConfirmationPopover onOpen={updateSafetyStockDialog} onConfirm={onConfirmUpdateSafetyStock} onClose={handleUpdateSafetyStockDialogClose} action="Update Safety Stock" />
      <ConfirmationPopover onOpen={calculateIsMbrDialog} onConfirm={onConfirmCalculateIsMbr} onClose={handleCalculateIsMbrDialogClose} action="Calculate IS MBR" />
    </Grid>


  );
}
